<template>
  <div v-cloak v-cloak v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <el-dialog
      @opened ="openedDialog"
      title="Config user role"
      :visible.sync="configUserRoleDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      @closed ="closeDialog"
      width="900px!important"
      size="small">
        Select Roles For User: {{rowVal.ebp_user_name}}
        <div style="height: 70vh;overflow-y: auto;overflow-x: hidden;">
          <d1-vue-component ref="basicComponent" :options="generateOption" :dataFacetKey="dataFacetKey" :d1CoreBaseUrl="baseAcsUrl"  :d1ClientBaseUrl="baseUrl"  @handleperationAfterQuery="handleFirstQuery"></d1-vue-component>
        </div>

      <span slot="footer" class="dialog-footer">
              <el-button size="small" type="success" @click="saveConfingRole">Save</el-button>
              <el-button size="small" class="ml30" @click="hideConfigRoleDialog">close</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

  import d1VueComponent from '@/components/d1/acs-d1-vue-component'

  export default {
    components: {
       d1VueComponent
    },
    data(){
      return{
        firstTime : true,


        configUserRoleDialogVisible: false,
        dataLoading: false,
        rowVal:{},
        dataFacetKey:"acs_role_list",
        generateOption: {
          moreOperationAfterQuery:true,
          queryUrl: 'mdm-common/acs/role/get-roles?sort=gmt_modified,DESC&app_key='+this.appKey,
          showPagination: false,
          showForm:false,
          showTableSelection :true

        }
      }
    },
    computed: {

    },


    created(){

    },


    methods: {
      showConfigRoleDialog(row){
        this.rowVal = row;
        console.log(row);
        this.configUserRoleDialogVisible = true;

      },
      hideConfigRoleDialog(){
        this.configUserRoleDialogVisible = false;
      },
      saveConfingRole(){
        let url = this.baseAcsUrl + '/acs/user-role';
        let userRoles = {};
        let userId = this.rowVal.id;

        let selection = this.$refs.basicComponent.getSelection();
        if(!selection || selection.length == 0){
          this.$message.warning("Please select at least one record");
          return;
        }
        let roleIds = [];
        for(let i in selection){
          roleIds.push(selection[i].id);
        }
        userRoles.userId = userId;
        userRoles.roleIdList = roleIds;

        this.dataLoading = true;
        this.http.post(url,userRoles).then(resp =>{
          this.$message.success('Successful operation ');
          this.configUserRoleDialogVisible = false;
          this.dataLoading = false;
          this.$emit("saveSuccess");
        }).catch(error => {
          this.dataLoading = false;
          console.info(error);
          this.$emit("saveFail");

        });
      },
      //第一次查询 (),这种控制一步与opened的关联是否有问题
      handleFirstQuery(tableDa){
        this.selectUserInfo();
      },
      selectUserInfo(){
        this.dataLoading = true;
        let url = this.baseAcsUrl + '/acs/user-role?userId=' + this.rowVal.id;
        this.http.get(url).then(resp =>{
          let data = resp.data;
          console.log(data);
          if(data){
            let tableData = this.$refs.basicComponent.getTableData();
            let mySelection = [];
            for(let i in tableData){
              for(let j in data){
                if(tableData[i].id == data[j]){
                  mySelection.push(tableData[i]);
                  break;
                }
              }
            }
            this.$refs.basicComponent.toggleSelection(mySelection,true);
            this.dataLoading = false;
          }

        }).catch(error =>{
          this.dataLoading = false;
        })
      },
      openedDialog(){

        this.$nextTick(()=>{
          if(!this.firstTime){
            this.selectUserInfo();
            this.dataLoading = false;

          }
        })
      },
      closeDialog(){
        this.firstTime = false;
        this.$refs.basicComponent.clearSelection();
      }

    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }
 .el-form-item /deep/ .el-select{
   display: inline-block;
   width: 86%;
  }
  .add-banner-group  /deep/ .el-form-item__label{
    width: 148px !important;
  }
  .add-banner-group /deep/ .el-form-item__content{
    margin-left: 148px!important;
  }
  div /deep/ .el-dialog {
    margin-top: 0 !important;
    position: fixed !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>



// WEBPACK FOOTER //
// src/view/acs/user/dialog/config_user_role.vue